function tickFormatter(value: number): string {
  // formatting axis tick line labels to the thousandth with a k appended, sans 0
  if (value > 1000) {
    const thousandth: number = value / 1000;
    return `${thousandth}${(value !== 0) ? "k" : ""}`;
  }

  return value.toString();
}

const colors = {
  blue: "rgba(5, 110, 223, .55)",
  cyan: "rgba(32, 197, 197, 0.7)",
  green: "rgba(185, 243, 183, 1)",
  lightBlue: "rgba(159, 204, 253, 1)",
  lightGreen: "rgba(185, 243, 183, .50)",
};

export {
  colors,
  tickFormatter,
};